import type { ProxyLocation } from "@/content/proxyLocations";

/**
 * The structured data every published country page prints, as its template
 * writes it: one breadcrumb, the index by its full name and the country named
 * but not linked, in the template's own layout. It is not the visible
 * breadcrumb, which leads to the features page. The country is named as the
 * page's `h1` names it ("USA Proxy", "United Kingdom Proxy"), unescaped.
 */
export function locationSchema(country: ProxyLocation): string {
  return `
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Proxy Locations",
        "item": "https://www.webshare.io/proxy-locations"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "${country.heading}"
      }]
    }
`;
}
